export default {
  title: "Rejected Corrective Work",
  label_corrective_work_statement: "Corrective Work Statement",
}
